import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, switchMap, throwError } from 'rxjs';

import { ProtectedActionsService } from 'src/services/protected-actions.service';

const REAUTH_REQUIRED_CODE = 'reauth.required';

@Injectable({ providedIn: 'root' })
export class ReAuthInterceptor implements HttpInterceptor {

    constructor(private protectedActionsService: ProtectedActionsService) {}

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(req).pipe(
            catchError(error => {
                if (error.status === 401 && this.isReAuthRequired(error)) {
                    return this.protectedActionsService.requestReAuth().pipe(
                        switchMap(() => next.handle(req))
                    );
                }
                return throwError(() => error);
            })
        );
    }

    private isReAuthRequired(error: HttpErrorResponse): boolean {
        return error.error?.globalErrors?.some((e: { code?: string }) => e.code === REAUTH_REQUIRED_CODE) ?? false;
    }
}
